export default __webpack_public_path__ + "static/media/drag-icon.092f7610.svg";